import { render, staticRenderFns } from "./MerchantEdit.vue?vue&type=template&id=f5935542&"
import script from "./MerchantEdit.vue?vue&type=script&lang=js&"
export * from "./MerchantEdit.vue?vue&type=script&lang=js&"
import style0 from "./MerchantEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports